import { render } from "./barcodeComponent.vue?vue&type=template&id=2ba7ca60&scoped=true"
import script from "./barcodeComponent.vue?vue&type=script&lang=js"
export * from "./barcodeComponent.vue?vue&type=script&lang=js"

import "./barcodeComponent.vue?vue&type=style&index=0&id=2ba7ca60&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba7ca60"]])

export default __exports__